import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../../shared/ui/kit/utils';

interface EmptyStateProps {
    searchQuery?: string;
    filterType?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ searchQuery, filterType }) => {
    const isSearch = searchQuery && searchQuery.length > 0;
    const isFilter = filterType && filterType !== 'all';

    let title = 'Нет сообщений';
    let description = 'У вас пока нет уведомлений';
    let icon = 'inbox';

    if (isSearch) {
        title = 'Ничего не найдено';
        description = `По запросу "${searchQuery}" не найдено сообщений`;
        icon = 'search';
    } else if (isFilter) {
        title = 'Нет сообщений';
        description = 'В этом разделе пока нет уведомлений';
        icon = 'filter';
    }

    const icons: Record<string, React.ReactNode> = {
        inbox: (
            <svg width="32" height="32" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
                <path d="M22 12h-6l-2 3h-4l-2-3H2"/>
                <path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"/>
            </svg>
        ),
        search: (
            <svg width="32" height="32" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
                <circle cx="11" cy="11" r="8"/>
                <line x1="21" y1="21" x2="16.65" y2="16.65"/>
            </svg>
        ),
        filter: (
            <svg width="32" height="32" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
                <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/>
            </svg>
        ),
    };

    return (
        <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            className="flex flex-col items-center justify-center py-16 px-6 text-center"
        >
            <motion.div
                animate={{ y: [0, -8, 0] }}
                transition={{ duration: 3, repeat: Infinity, ease: 'easeInOut' }}
                className={cn(
                    'w-20 h-20 rounded-2xl flex items-center justify-center mb-6',
                    'bg-gray-100 dark:bg-white/5',
                    'border border-black/[.06] dark:border-white/[.06]',
                    'text-gray-400 dark:text-gray-500'
                )}
            >
                {icons[icon]}
            </motion.div>
            
            <h3 className="text-[16px] font-semibold text-gray-900 dark:text-gray-100 mb-2">
                {title}
            </h3>
            <p className="text-[13px] text-gray-500 dark:text-gray-400 max-w-[240px] leading-relaxed">
                {description}
            </p>

            {(isSearch || isFilter) && (
                <motion.button
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    className={cn(
                        'mt-6 px-4 py-2 rounded-lg text-[13px] font-medium',
                        'bg-white dark:bg-white/5',
                        'border border-black/[.07] dark:border-white/[.07]',
                        'text-gray-700 dark:text-gray-300',
                        'hover:bg-gray-50 dark:hover:bg-white/10',
                        'transition-colors'
                    )}
                >
                    Сбросить фильтры
                </motion.button>
            )}
        </motion.div>
    );
};